export type TemplateFamilyMetadata = Record<string, unknown>;

export const isSingleCheckoutQuantityMode = (
  metadata?: TemplateFamilyMetadata | null,
) => metadata?.checkout_quantity_mode === 'single';
